import axios from 'axios';
import { h, render } from 'preact'
import AnnuityChatbot from './annuity_chatbot';
import Utility from '../../classes/Utility';

const urlParams = new URLSearchParams(window.location.search);
const ShowChatbot = (chatbot_type) => {
  window.chatbot_type = chatbot_type
  window.chatbot_forceshow_param = 'annuityemail'
  if (urlParams.get(window.chatbot_forceshow_param) == 'true') {
    replaceDom.apply(this);
  } else {
    window.addEventListener('scroll', replaceDom);
  }
}

const replaceDom = async () => {
  window.removeEventListener('scroll', replaceDom);
  const elementSelector = 'annuity-questionaire';
  const parent = document.querySelector(`.multistep-chat-box[data-chatbot-key^=${elementSelector}]`);
  const chatBotConfig = parent.dataset;
  const listOfPagesNotShow = chatBotConfig.listOfPagesNotShow ? chatBotConfig.listOfPagesNotShow.split(',') : [];

  const urlParamsOveride = urlParams.get(window.chatbot_forceshow_param) == 'true';
  if (urlParamsOveride) {
    Utility.resetSession('forceshow');
  }

  try {
    const response = await axios.get('/api/geo_country/');
    const userGeoCountry = response.data;
    if (userGeoCountry != 'US') {
      return;
    }
    // if the current page is not in the list of urls to not show
    if (!listOfPagesNotShow.some(page => (window.location.pathname.includes(page)))) {
      Utility.getConfigData({
        type: 'current_user'
      }).then(res => {
        const { data } = res;
        const { premium } = data;
        const uuid = Utility.getCookie('mid')
        setTimeout(() => {
          if (uuid == 'unknown') {
            setTimeout(() => {
              render(<AnnuityChatbot chatBotConfig={chatBotConfig} premium={premium} />, parent);
            }, 2000);
          } else {
            render(<AnnuityChatbot chatBotConfig={chatBotConfig} premium={premium} />, parent);
          }
        }, 200);
      })
    }
  } catch (e) {
  }
}

export default ShowChatbot;
